import { createAction, handleActions } from 'redux-actions'

const setData = createAction('SCREENS/PLANNER/SET_DATA')
const resetData = createAction('SCREENS/PLANNER/RESET_DATA')

const defaultState = {
  periods: [],
  rows: [],
}

const reducer = handleActions(
  {
    [setData]: (state, action) => action.payload,
    [resetData]: () => defaultState,
  },
  defaultState,
)

export { setData, resetData, reducer }
